/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * BANNER = einer sichtbar, rotierend. KASTEN = einer, fest.
 * LISTE = alle untereinander. TREPPCHEN = die ersten drei, gestaffelt.
 * TREPPCHEN_RANGLISTE = alle Plaetze als BALKEN IN EINER REIHE, in der
 * Ordnung des Treppchens: Zweiter links, Erster in der Mitte, Dritter
 * rechts, dahinter der Rest — „2 - 1 - 3 - 4 - 5 - 6" (Vorgabe des
 * Betreibers vom 17.09.2026). Die Hoehe faellt mit dem Platz;
 * `maxItems` sagt, wie viele Balken stehen.
 * 
 * ZUSAMMEN MIT `LISTE` SIND DAS ZWEI ANSICHTEN DERSELBEN PLAETZE, und
 * `display` ist das Attribut zum Umschalten: „zwei verschiedene
 * Ansichten … jeweils für max 6. Balken und Rangliste. Mit Attribut zum
 * Umschalten."
 * @export
 */
export const DatabaseSubDbListDisplay = {
    Banner: 'BANNER',
    Kasten: 'KASTEN',
    Liste: 'LISTE',
    Treppchen: 'TREPPCHEN',
    TreppchenRangliste: 'TREPPCHEN_RANGLISTE'
} as const;
export type DatabaseSubDbListDisplay = typeof DatabaseSubDbListDisplay[keyof typeof DatabaseSubDbListDisplay];


export function DatabaseSubDbListDisplayFromJSON(json: any): DatabaseSubDbListDisplay {
    return DatabaseSubDbListDisplayFromJSONTyped(json, false);
}

export function DatabaseSubDbListDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbListDisplay {
    return json as DatabaseSubDbListDisplay;
}

export function DatabaseSubDbListDisplayToJSON(value?: DatabaseSubDbListDisplay | null): any {
    return value as any;
}

